import React from 'react';
import { cn } from '../../lib/utils';
import { Input } from '../ui/input';
import { Euro } from 'lucide-react';
import { RATE_TYPES as rateTypeOptions } from '../../constants/profileContract';

export function RateInput({
  amount,
  rateType,
  onAmountChange,
  onRateTypeChange,
  profileType = 'musician',
  className,
}) {
  const options = rateTypeOptions[profileType] || rateTypeOptions.musician;

  return (
    <div className={cn('space-y-6', className)}>
      {/* Amount Input */}
      <div className="relative max-w-xs mx-auto">
        <div className="absolute left-4 top-1/2 -translate-y-1/2 flex items-center gap-1 text-white/40">
          <Euro className="h-5 w-5" />
        </div>
        <Input
          type="number"
          value={amount || ''}
          onChange={(e) => onAmountChange(e.target.value ? parseInt(e.target.value) : null)}
          placeholder="0"
          min="0"
          max="5000"
          className="h-16 pl-12 pr-4 text-center text-3xl font-semibold bg-[#151515] border-white/[0.08] focus:border-amber-500/50 text-white placeholder:text-white/20"
          data-testid="rate-amount-input"
        />
        <span className="absolute right-4 top-1/2 -translate-y-1/2 text-white/40 text-sm">
          EUR
        </span>
      </div>

      {/* Rate Type Selection */}
      <div className="space-y-2">
        <p className="text-xs text-white/40 uppercase tracking-wider text-center mb-3">
          Rate Type
        </p>
        <div className="flex flex-col sm:flex-row gap-2 justify-center">
          {options.map((option) => {
            const isSelected = rateType === option.value;
            return (
              <button
                key={option.value}
                type="button"
                onClick={() => onRateTypeChange(option.value)}
                className={cn(
                  'flex-1 px-4 py-3 rounded-xl border transition-all text-left sm:text-center',
                  isSelected
                    ? 'bg-amber-500/20 border-amber-500/50'
                    : 'bg-[#151515] border-white/[0.08] hover:bg-white/[0.05] hover:border-white/20'
                )}
                data-testid={`rate-type-${option.value}`}
              >
                <div className={cn('font-medium text-sm', isSelected ? 'text-amber-400' : 'text-white/80')}>
                  {option.label}
                </div>
                <div className="text-xs text-white/40 mt-0.5">{option.desc}</div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
